import React from "react";

function Summary({ cartItems, cartSummary }) {
  const subtotal = Number(cartSummary.subtotal || 0);
  const total = Number(cartSummary.total || 0);
  const discount = Number(cartSummary.discount || 0);
  const shipping = Number(cartSummary.shipping || 0);

  const totalWithoutDiscount = cartItems.reduce((sum, item) => {
    return sum + item.mrp * item.quantity;
  }, 0);

  const totalSaving = (cartSummary.subtotal || 0) - (cartSummary.total || 0);

  return (
    <>
      <ul className="list-total">
        {/* {totalWithoutDiscount && (
          <li className="total-item d-flex justify-content-between">
            <span>SubTotal:</span>
            <span className="fw-medium text-decoration-line-through">
              ₹{totalWithoutDiscount.toFixed(2)}
            </span>
          </li>
        )} */}

        <li className="total-item d-flex justify-content-between">
          <span>Sub Total:</span>
          <span className="fw-medium">₹{subtotal.toFixed(2)}</span>
        </li>

        {discount > 0 && (
          <li className="total-item d-flex justify-content-between">
            <span>Coupon Discount:</span>
            <span className="fw-medium text-success">
              -₹{discount.toFixed(2)}
            </span>
          </li>
        )}

        <li className="total-item d-flex justify-content-between">
          <span>Shipping:</span>
          <span className="fw-medium">+ ₹{shipping.toFixed(2)}</span>
        </li>
      </ul>

      <hr />

      <div className="subtotal d-flex justify-content-between">
        <span>Total:</span>
        <span className="total-price-order fw-bold">₹{total.toFixed(2)}</span>
      </div>

      {totalSaving > 0 && (
        <div className="text-success mt-2">
          You saved ₹{totalSaving.toFixed(2)} on this order!
        </div>
      )}
    </>
  );
}

export default Summary;
